import { getAllNestedWatchPaths } from '@launcher/utils';
import { logger } from '@services/logger/logger.service';
import { getErrorCode } from '@services/logger/scrubFilePaths';

import { EnsureDirCallbacks } from '..';

const callbacks: EnsureDirCallbacks = {};

export async function ensureWatchPathFolders(watchPaths: string[]): Promise<void> {
  logger.info('DESKTOP', `Creating ${watchPaths.length} WatchPath folders...`);

  try {
    const foldersToCreate = await getAllNestedWatchPaths(watchPaths);

    await Promise.all(foldersToCreate.map((path) => window.electron.ensureDir(path, callbacks)));
  } catch (error) {
    logger.error(
      'DESKTOP',
      `Cannot set up WatchPath folders (${getErrorCode(error)})`,
      undefined,
      false,
    );
  }
}
